import { render, staticRenderFns } from "./StudentEditTabPhoneNumbers.vue?vue&type=template&id=e2a1f6c4&scoped=true&"
import script from "./StudentEditTabPhoneNumbers.vue?vue&type=script&lang=js&"
export * from "./StudentEditTabPhoneNumbers.vue?vue&type=script&lang=js&"
import style0 from "./StudentEditTabPhoneNumbers.vue?vue&type=style&index=0&id=e2a1f6c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a1f6c4",
  null
  
)

export default component.exports